/* eslint-disable no-unused-vars,no-labels,camelcase,no-lone-blocks */
module.exports = {
  pt_BR: {
    REASON_CODES: {
      forgot_password_used: 'Este token já foi utilizado',
      data_not_found: 'Registro não encontrado',
      external_connection_exception: 'Conexão com o servidor de importação dos usuários inativa',
      recovery_not_permitted: 'Contate o administrador para recuperar a senha.',
      CHANGE_TOKEN_NOT_FOUND: 'O token informado é inválido',
      USER_NOT_FOUND: 'Usuário não encontrado',
      USER_INACTIVE: 'Usuário não está ativo',
      USER_NOT_IMPORTED: 'Usuário não está importado no sistema',
      WRONG_CURRENT_PASSWORD: 'Senha atual inválida',
      CPF_DUPLICATE: 'CPF duplicado',
      EMAIL_DUPLICATE_REGISTER: 'O e-mail informado já foi cadastrado para outro usuário existente',
      AGENCY_DUPLICATE_REGISTER: 'Já existe um usuário cadastrado para essa agência',
      SUPERINTENDENCE_DUPLICATE_REGISTER: 'Já existe um usuário cadastrado para essa superintendência',
      USER_CANNOT_BE_NULL: 'Usuário não pode ser nulo',
      USER_PHOTO_NOT_SENT: 'Foto não enviada',
      PROFILE_DUPLICATE: 'Já existe um perfil existente com o nome informado',
      FAIL_TO_GET_ENTITY_USERS: 'Falha na requisição da lista de usuário de uma entidade',
      CANNOT_CHANGE_PASSWORD: 'A troca de senha não permitida para usuários da FUNDAÇÂO. Contacte seu administrador de rede',
      ENTITY_NOT_FOUND: 'Entidade não encontrada',
      ENTITY_CNPJ_DUPLICATE: 'Entidade com este CNPJ já registrada',
      ENTITY_REGISTER_ERROR: 'Falha ao cadastrar proposta',
      APPROVAL_SAME_APPRAISER: 'Avaliador das aprovações da entidade não pode ser o mesmo',
      APPROVAL_SAME_APPRAISER_CREATE_ENTITY: 'Avaliador das aprovações da entidade não pode ser o mesmo usuário que cadastrou a entidade',
      NO_APPROVERS: 'Não existem avaliadores cadastrados',
      FAIL_TO_CLONE_APPROVAL: 'Falha ao clonar a aprovação',
      PRE_ANALYSIS_APPROVAL_SAME_APPRAISER: 'Avaliador da pré-análise não pode ser o mesmo que fez a primeira aprovação',
      PRE_ANALYSIS_APPROVAL_SAME_APPRAISER_CREATE_ENTITY: 'Avaliador da pré-análise não pode ser o mesmo usuário que cadastrou a proposta',
      INVALID_REQUEST_APPROVAL_RESULT: 'O RequestApprovalResult é inválido.',
      NOTIFICATION_NOT_FOUND: 'Notificação não encontrada',
      APPROVAL_ITEM_NOT_FOUND: 'Item não encontrado',
      DATA_NOT_FOUND: 'Dados não encontrados',
      DOCUMENT_CANNOT_BE_NULL: 'O documento não pode ser nulo',
      DOCUMENT_NOT_SENT: 'Documento não enviado',
      DOCUMENT_TOO_LARGE: 'Documento muito grande',
      DOCUMENT_NOT_FOUND: 'Documento não encontrado',
      UNSENT_FILE_INFORMATION: 'Informações do arquivo não enviadas',
      FAIL_TO_CLEAN_BLOB: 'Falha ao limpar o BLOB',
      FAIL_TO_HANDLE_DOCUMENT: 'Falha na manipulação do arquivo',
      FAIL_TO_DELETE_DOCUMENT: 'Falha na exclusão do arquivo',
      FILE_TOO_LARGE: 'Arquivo muito grande',
      INVALID_FILE_TYPE: 'Tipo de arquivo não permitido',
      PROPOSAL_REGISTER_ERROR: 'Falha ao cadastrar proposta'
    },
    approval: {
      OPENED: 'Enviado para aprovação',
      OPENED_4_APPROVE: 'Pendente de aprovação',
      APPROVED: 'Aprovada',
      REJECTED: 'Rejeitada',
      EXECUTED: 'Executada',
      preCondition: 'Sua solicitação foi processada e encaminhada para aprovação superior, assim que for aprovada sua requisição será processada.',
      inbox: 'Caixa de entrada',
      detail: 'Detalhes'
    },
    login: {
      sign_in_to_start_your_session: 'Faça seu acesso',
      login_email: 'Login ou E-mail',
      password: 'Senha',
      remember_me: 'Lembrar-me',
      sign_in: 'Acessar',
      sign_in_loading: 'Carregando',
      or: 'OU',
      sign_in_facebook: 'Acessar usando o Facebook',
      sign_in_google: 'Acessar usando Google+',
      forgot_my_password: 'Esqueci minha senha',
      register_a_new_membership: 'Cadastrar um novo usuário',
      developed_by: 'Desenvolvido por',
      error: 'Erro:',
      error_auth: 'Não foi possível realizar seu login, verifique seu usuário ou senha.',
      error_general: 'Falha ao realizar o login, contate o administrador do sistema.'
    },
    pwdConfirm: {
      title: 'Confirmar operação',
      description: 'Para confirmar está ação por favor digite sua senha:',
      password: 'Informe a senha atual',
      cancel: 'Cancelar',
      confirm: 'Confirmar',
      failed: 'Senha incorreta, não foi possível completar sua operação'
    },
    recovery: {
      remember_password: 'Lembrar senha',
      enter_login: 'Digite o login ou o seu e-mail',
      login_email: 'Login ou E-mail',
      recover_password: 'Recuperar senha',
      back_to_login: 'Voltar para Login'
    },
    authority: {
      register: {
        'usuario-agencia-editar': 'Alterar Cadastro',
        'usuario-agencia-visualizar': 'Visualizar Cadastro',
        'usuario-agencia-novo': 'Criar Cadastro',
        'usuario-agencia-ativar-inativar': 'Ativar / Inativar Cadastro',
        'usuario-agencia-atribuir-perfil': 'Atribuir Perfil',
        'usuario-agencia-visualizar-por-mim': 'Visualizar Criados Por Mim',
        'usuario-agencia-configurar': 'Configurar',
        'usuario-fundacao-editar': 'Alterar Cadastro',
        'usuario-fundacao-visualizar': 'Visualizar Cadastro',
        'usuario-fundacao-ativar-inativar': 'Ativar / Inativar Cadastro',
        'usuario-fundacao-atribuir-perfil': 'Atribuir Perfil',
        'usuario-fundacao-visualizar-por-mim': 'Visualizar Criados Por Mim',
        'usuario-fundacao-configurar': 'Configurar',
        'usuario-entidade-editar': 'Alterar Cadastros',
        'usuario-entidade-visualizar': 'Visualizar Cadastro',
        'usuario-entidade-novo': 'Criar Cadastro',
        'usuario-entidade-ativar-inativar': 'Ativar / Inativar Cadastro',
        'usuario-entidade-atribuir-perfil': 'Atribuir Perfil',
        'usuario-entidade-visualizar-por-mim': 'Visualizar Criados Por Mim',
        'usuario-entidade-configurar': 'Configurar',
        'usuario-estrategico-editar': 'Alterar Cadastro',
        'usuario-estrategico-visualizar': 'Visualizar Cadastro',
        'usuario-estrategico-novo': 'Criar Cadastro',
        'usuario-estrategico-ativar-inativar': 'Ativar / Inativar Cadastro',
        'usuario-estrategico-atribuir-perfil': 'Atribuir Perfil',
        'usuario-estrategico-visualizar-por-mim': 'Visualizar Criados Por Mim',
        'usuario-estrategico-configurar': 'Configurar',
        'usuario-superintendencia-editar': 'Alterar Cadastro',
        'usuario-superintendencia-visualizar': 'Visualizar Cadastro',
        'usuario-superintendencia-novo': 'Criar Cadastro',
        'usuario-superintendencia-ativar-inativar': 'Ativar / Inativar Cadastro',
        'usuario-superintendencia-atribuir-perfil': 'Atribuir Perfil',
        'usuario-superintendencia-visualizar-por-mim': 'Visualizar Criados Por Mim',
        'usuario-superintendencia-configurar': 'Configurar',
        'perfil-editar': 'Alterar Cadastro',
        'perfil-visualizar': 'Visualizar Cadastro',
        'perfil-novo': 'Criar Cadastro',
        'perfil-ativar-inativar': 'Ativar / Inativar Cadastro',
        'perfil-atribuir-usuario': 'Atribuir Usuário',
        'permissao-editar': 'Alterar Cadastro',
        'permissao-visualizar': 'Visualizar  Cadastro',
        'entidade-editar': 'Alterar Cadastro',
        'entidade-excluir': 'Excluir Cadastro',
        'entidade-configurar': 'Cadastro de Entidade',
        'entidade-credenciar': 'Credenciar',
        'entidade-cadastro-simplificado': 'Criar Cadastro Simplificado',
        'entidade-cadastro-completo': 'Criar Cadastro Completo',
        'entidade-ativar-inativar': 'Ativar / Inativar Cadastro',
        'entidade-validar': 'Validar Cadastro',
        'entidade-visualizar': 'Visualizar Cadastro',
        'entidade-visualizar-por-mim': 'Visualizar Criados Por Mim',
        'minha-entidade-visualizar': 'Visualizar Cadastro',
        'minha-entidade-editar': 'Alterar Cadastro',
        'edital-editar': 'Alterar Cadastro',
        'edital-visualizar': 'Visualizar Cadastro',
        'edital-novo': 'Criar Cadastro',
        'edital-ativar-inativar': 'Ativar / Inativar Cadastro',
        'documento-editar': 'Alterar Cadastro',
        'documento-visualizar': 'Visualizar Cadastro',
        'documento-novo': 'Criar Cadastro',
        'documento-ativar-inativar': 'Ativar / Inativar Cadastro',
        'documento-configurar': 'Documentos do Sistema',
        'tipo-documento-editar': 'Alterar Cadastro',
        'tipo-documento-visualizar': 'Visualizar Cadastro',
        'tipo-documento-novo': 'Criar Cadastro',
        'tipo-documento-ativar-inativar': 'Ativar / Inativar Cadastro',
        'perfil-atribuido-configurar': 'Configurar',
        'perfil-atribuido-editar': 'Atribuir',
        'perfil-atribuido-visualizar': 'Visualizar',
        'minha-proposta-visualizar': 'Visualizar Cadastro',
        'minha-proposta-editar': 'Alterar Cadastro',
        'meu-parceiro-estrategico-visualizar': 'Visualizar Cadastro',
        'meu-parceiro-estrategico-editar': 'Alterar Cadastro',
        'proposta-visualizar-por-mim': 'Visualizar Criados Por Mim',
        'proposta-visualizar': 'Visualizar Cadastro',
        'proposta-configurar': 'Cadastro de Proposta',
        'proposta-liberar': 'Liberar Cadastro',
        'proposta-cadastro-simplificado': 'Criar Cadastro Simplificado',
        'proposta-cadastro-completo': 'Criar Cadastro Completo',
        'pre-analise-primeira-aprovacao-validar': 'Validar Primeira Aprovação',
        'pre-analise-segunda-aprovacao-validar': 'Validar Segunda Aprovação',
        'aceite-proposta-validar': 'Validar Aceite',
        'analise-aprovacao-validar': 'Validar Aprovação',
        'analise-pendencia-aprovacao-validar': 'Validar Pendência da Aprovação',
        'deferimento-aprovacao-validar': 'Validar Deferimento',
        'preparacao-documentos-aprovacao-validar': 'Validar Preparação de Documentos',
        'formalizacao-projetos-aprovacao-validar': 'Validar Formalizar Projetos',
        'parceiro-estrategico-editar': 'Alterar Cadastro',
        'parceiro-estrategico-visualizar': 'Visualizar Cadastro',
        'parceiro-estrategico-novo': 'Criar Cadastro',
        'parceiro-estrategico-ativar-inativar': 'Ativar / Inativar Cadastro',
        'parceiro-estrategico-validar': 'Validar Cadastro',
        'fav-editar': 'Acesso ao Módulo',
        'ged-editar': 'Acesso ao Módulo',
        'solicitacao-pagamento-editar': 'Criar solicitação',
        'solicitacao-contrapartida-editar': 'Criar solicitação',
        'solicitacao-adiantamento-editar': 'Criar solicitação',
        'solicitacao-prestacaocontas-editar': 'Criar solicitação',
        'solicitacao-devolucaoadiantamento-editar': 'Criar solicitação',
        'solicitacao-configurar': 'Cadastro de Solicitação',
        'solicitacao-pagamento-analisar': 'Analisar solicitação',
        'solicitacao-pagamento-acompanhar': 'Acompanhar solicitação',
        'solicitacao-contrapartida-analisar': 'Analisar solicitação',
        'solicitacao-adiantamento-analisar': 'Analisar solicitação',
        'solicitacao-adiantamento-aprovar': 'Autorizar solicitação',
        'solicitacao-adiantamento-analisefinanceira': 'Fazer Análise Financeira da solicitação',
        'solicitacao-devolucaoadiantamento-analisar': 'Analisar solicitação',
        'solicitacao-devolucaoadiantamento-analisefinanceira': 'Fazer Análise Financeira da solicitação',
        'solicitacao-prestacaocontas-analisar': 'Analisar solicitação',
        'solicitacao-prestacaocontas-analisefinanceira': 'Autorizar solicitação',
        'relatorio-execucao-editar': 'Editar relatório de execução',
        'relatorio-execucao-enviar': 'Enviar relatório de execução',
        'relatorio-execucao-aprovar-envio': 'Aprovar envio de relatório de execução',
        'relatorio-execucao-aprovar-pendencia': 'Aprovar pendência de relatório de execução',
        'relatorio-erp-novo': 'Criar',
        'relatorio-erp-editar': 'Editar',
        'relatorio-erp-excluir': 'Excluir',
        'relatorio-erp-visualizar': 'Visualizar',
        'relatorio-erp-emissao': 'Emissão',
        'dashboard-propostas': 'Propostas',
        'dashboard-projetos': 'Projetos',
        'dashboard-saude-sistema': 'Saúde do sistema',
        'dashboard-controle-propostas': 'Controle de propostas',
        'dashboard-mapa-projetos': 'Mapa de projetos',
        'meu-projeto-visualizar': 'Visualizar Meu Projeto',
        'projeto-visualizar-por-mim': 'Visualizar Criados Por Mim',
        'projeto-visualizar': 'Visualizar Projetos',
        'entidade-cadastro-entidade-proposta-simplificado': 'Criar Cadastro Entidade/Proposta Simplificada',
        'relatorio-execucao-aprovar-conhecimento': 'Aprovar relatório de execução enviado para conhecimento',
        USUARIO_AGENCIA_EDITAR: 'Alterar Cadastro',
        USUARIO_AGENCIA_VISUALIZAR: 'Visualizar Cadastro',
        USUARIO_AGENCIA_NOVO: 'Criar Cadastro',
        USUARIO_AGENCIA_ATIVAR_INATIVAR: 'Ativar / Inativar Cadastro',
        USUARIO_AGENCIA_ATRIBUIR_PERFIL: 'Atribuir Perfil',
        USUARIO_AGENCIA_VISUALIZAR_POR_MIM: 'Visualizar Criados Por Mim',
        USUARIO_AGENCIA_CONFIGURAR: 'Configurar',
        USUARIO_FUNDACAO_EDITAR: 'Alterar Cadastro',
        USUARIO_FUNDACAO_VISUALIZAR: 'Visualizar Cadastro',
        USUARIO_FUNDACAO_ATIVAR_INATIVAR: 'Ativar / Inativar Cadastro',
        USUARIO_FUNDACAO_ATRIBUIR_PERFIL: 'Atribuir Perfil',
        USUARIO_FUNDACAO_VISUALIZAR_POR_MIM: 'Visualizar Criados Por Mim',
        USUARIO_FUNDACAO_CONFIGURAR: 'Configurar',
        USUARIO_ENTIDADE_EDITAR: 'Alterar Cadastros',
        USUARIO_ENTIDADE_VISUALIZAR: 'Visualizar Cadastro',
        USUARIO_ENTIDADE_NOVO: 'Criar Cadastro',
        USUARIO_ENTIDADE_ATIVAR_INATIVAR: 'Ativar / Inativar Cadastro',
        USUARIO_ENTIDADE_ATRIBUIR_PERFIL: 'Atribuir Perfil',
        USUARIO_ENTIDADE_VISUALIZAR_POR_MIM: 'Visualizar Criados Por Mim',
        USUARIO_ENTIDADE_CONFIGURAR: 'Configurar',
        USUARIO_ESTRATEGICO_EDITAR: 'Alterar Cadastro',
        USUARIO_ESTRATEGICO_VISUALIZAR: 'Visualizar Cadastro',
        USUARIO_ESTRATEGICO_NOVO: 'Criar Cadastro',
        USUARIO_ESTRATEGICO_ATIVAR_INATIVAR: 'Ativar / Inativar Cadastro',
        USUARIO_ESTRATEGICO_ATRIBUIR_PERFIL: 'Atribuir Perfil',
        USUARIO_ESTRATEGICO_VISUALIZAR_POR_MIM: 'Visualizar Criados Por Mim',
        USUARIO_ESTRATEGICO_CONFIGURAR: 'Configurar',
        USUARIO_SUPERINTENDENCIA_EDITAR: 'Alterar Cadastro',
        USUARIO_SUPERINTENDENCIA_VISUALIZAR: 'Visualizar Cadastro',
        USUARIO_SUPERINTENDENCIA_NOVO: 'Criar Cadastro',
        USUARIO_SUPERINTENDENCIA_ATIVAR_INATIVAR: 'Ativar / Inativar Cadastro',
        USUARIO_SUPERINTENDENCIA_ATRIBUIR_PERFIL: 'Atribuir Perfil',
        USUARIO_SUPERINTENDENCIA_VISUALIZAR_POR_MIM: 'Visualizar Criados Por Mim',
        USUARIO_SUPERINTENDENCIA_CONFIGURAR: 'Configurar',
        PERFIL_EDITAR: 'Alterar Cadastro',
        PERFIL_VISUALIZAR: 'Visualizar Cadastro',
        PERFIL_NOVO: 'Criar Cadastro',
        PERFIL_ATIVAR_INATIVAR: 'Ativar / Inativar Cadastro',
        PERFIL_ATRIBUIR_USUARIO: 'Atribuir Usuário',
        PERMISSAO_EDITAR: 'Alterar Cadastro',
        PERMISSAO_VISUALIZAR: 'Visualizar  Cadastro',
        ENTIDADE_EDITAR: 'Alterar Cadastro',
        ENTIDADE_EXCLUIR: 'Excluir Cadastro',
        ENTIDADE_CONFIGURAR: 'Cadastro de Entidade',
        ENTIDADE_CREDENCIAR: 'Credenciar',
        ENTIDADE_CADASTRO_SIMPLIFICADO: 'Criar Cadastro Simplificado',
        ENTIDADE_CADASTRO_COMPLETO: 'Criar Cadastro Completo',
        ENTIDADE_ATIVAR_INATIVAR: 'Ativar / Inativar Cadastro',
        ENTIDADE_VALIDAR: 'Validar Cadastro',
        ENTIDADE_VISUALIZAR: 'Visualizar Cadastro',
        ENTIDADE_VISUALIZAR_POR_MIM: 'Visualizar Criados Por Mim',
        MINHA_ENTIDADE_VISUALIZAR: 'Visualizar Cadastro',
        MINHA_ENTIDADE_EDITAR: 'Alterar Cadastro',
        EDITAL_EDITAR: 'Alterar Cadastro',
        EDITAL_VISUALIZAR: 'Visualizar Cadastro',
        EDITAL_NOVO: 'Criar Cadastro',
        EDITAL_ATIVAR_INATIVAR: 'Ativar / Inativar Cadastro',
        DOCUMENTO_EDITAR: 'Alterar Cadastro',
        DOCUMENTO_VISUALIZAR: 'Visualizar Cadastro',
        DOCUMENTO_NOVO: 'Criar Cadastro',
        DOCUMENTO_ATIVAR_INATIVAR: 'Ativar / Inativar Cadastro',
        DOCUMENTO_CONFIGURAR: 'Documentos do Sistema',
        TIPO_DOCUMENTO_EDITAR: 'Alterar Cadastro',
        TIPO_DOCUMENTO_VISUALIZAR: 'Visualizar Cadastro',
        TIPO_DOCUMENTO_NOVO: 'Criar Cadastro',
        TIPO_DOCUMENTO_ATIVAR_INATIVAR: 'Ativar / Inativar Cadastro',
        PERFIL_ATRIBUIDO_CONFIGURAR: 'Configurar',
        PERFIL_ATRIBUIDO_EDITAR: 'Atribuir',
        PERFIL_ATRIBUIDO_VISUALIZAR: 'Visualizar',
        MINHA_PROPOSTA_VISUALIZAR: 'Visualizar Cadastro',
        MINHA_PROPOSTA_EDITAR: 'Alterar Cadastro',
        MEU_PARCEIRO_ESTRATEGICO_VISUALIZAR: 'Visualizar Cadastro',
        MEU_PARCEIRO_ESTRATEGICO_EDITAR: 'Alterar Cadastro',
        PROPOSTA_VISUALIZAR_POR_MIM: 'Visualizar Criados Por Mim',
        PROPOSTA_VISUALIZAr: 'Visualizar Cadastro',
        PROPOSTA_CONFIGURAR: 'Cadastro de Proposta',
        PROPOSTA_LIBERAR: 'Liberar Cadastro',
        PROPOSTA_CADASTRO_SIMPLIFICADO: 'Criar Cadastro Simplificado',
        PROPOSTA_CADASTRO_COMPLETO: 'Criar Cadastro Completo',
        PRE_ANALISE_PRIMEIRA_APROVACAO_VALIDAR: 'Validar Primeira Aprovação',
        PRE_ANALISE_SEGUNDA_APROVACAO_VALIDAR: 'Validar Segunda Aprovação',
        ACEITE_PROPOSTA_VALIDAR: 'Validar Aceite',
        ANALISE_APROVACAO_VALIDAR: 'Validar Aprovação',
        ANALISE_PENDENCIA_APROVACAO_VALIDAR: 'Validar Pendência da Aprovação',
        DEFERIMENTO_APROVACAO_VALIDAR: 'Validar Deferimento',
        PREPARACAO_DOCUMENTOS_APROVACAO_VALIDAR: 'Validar Preparação de Documentos',
        FORMALIZACAO_PROJETOS_APROVACAO_VALIDAR: 'Validar Formalizar Projetos',
        PARCEIRO_ESTRATEGICO_EDITAR: 'Alterar Cadastro',
        PARCEIRO_ESTRATEGICO_VISUALIZAR: 'Visualizar Cadastro',
        PARCEIRO_ESTRATEGICO_NOVO: 'Criar Cadastro',
        PARCEIRO_ESTRATEGICO_ATIVAR_INATIVAR: 'Ativar / Inativar Cadastro',
        PARCEIRO_ESTRATEGICO_VALIDAR: 'Validar Cadastro',
        FAV_EDITAR: 'Acesso ao Módulo',
        GED_EDITAR: 'Acesso ao Módulo',
        SOLICITACAO_PAGAMENTO_EDITAR: 'Criar solicitação',
        SOLICITACAO_CONTRAPARTIDA_EDITAR: 'Criar solicitação',
        SOLICITACAO_ADIANTAMENTO_EDITAR: 'Criar solicitação',
        SOLICITACAO_PRESTACAOCONTAS_EDITAR: 'Criar solicitação',
        SOLICITACAO_DEVOLUCAOADIANTAMENTO_EDITAR: 'Criar solicitação',
        SOLICITACAO_CONFIGURAR: 'Cadastro de Solicitação',
        SOLICITACAO_PAGAMENTO_ANALISAR: 'Analisar solicitação',
        SOLICITACAO_PAGAMENTO_ACOMPANHAR: 'Acompanhar solicitação',
        SOLICITACAO_CONTRAPARTIDA_ANALISAR: 'Analisar solicitação',
        SOLICITACAO_ADIANTAMENTO_ANALISAR: 'Analisar solicitação',
        SOLICITACAO_ADIANTAMENTO_APROVAr: 'Autorizar solicitação',
        SOLICITACAO_ADIANTAMENTO_ANALISEFINANCEIRA: 'Fazer Análise Financeira da solicitação',
        SOLICITACAO_DEVOLUCAOADIANTAMENTO_ANALISAR: '_analisar solicitação',
        SOLICITACAO_DEVOLUCAOADIANTAMENTO_ANALISEFINANCEIRA: 'Fazer Análise Financeira da solicitação',
        SOLICITACAO_PRESTACAOCONTAS_ANALISAR: 'Analisar solicitação',
        SOLICITACAO_PRESTACAOCONTAS_ANALISEFINANCEIRA: 'Autorizar solicitação',
        RELATORIO_EXECUCAO_EDITAR: 'Editar relatório de execução',
        RELATORIO_EXECUCAO_ENVIAR: 'Enviar relatório de execução',
        RELATORIO_EXECUCAO_APROVAR_ENVIO: 'Aprovar envio de relatório de execução',
        RELATORIO_EXECUCAO_APROVAR_PENDENCIA: 'Aprovar pendência de relatório de execução',
        RELATORIO_ERP_NOVO: 'Criar',
        RELATORIO_ERP_EDITAR: 'Editar',
        RELATORIO_ERP_EXCLUIR: 'Excluir',
        RELATORIO_ERP_VISUALIZAR: 'Visualizar',
        RELATORIO_ERP_EMISSAO: 'Emissão',
        DASHBOARD_PROPOSTAS: 'Propostas',
        DASHBOARD_PROJETOS: 'Projetos',
        DASHBOARD_SAUDE_SISTEMA: 'Saúde do sistema',
        DASHBOARD_CONTROLE_PROPOSTAS: 'Controle de propostas',
        DASHBOARD_MAPA_PROJETOS: 'Mapa de projetos',
        MEU_PROJETO_VISUALIZAR: 'Visualizar Meu Projeto',
        PROJETO_VISUALIZAR_POR_MIM: 'Visualizar Criados Por Mim',
        PROJETO_VISUALIZAR: 'Visualizar Projetos',
        ENTIDADE_CADASTRO_ENTIDADE_PROPOSTA_SIMPLIFICADO: 'Criar Cadastro Entidade/Proposta Simplificada',
        RELATORIO_EXECUCAO_APROVAR_CONHECIMENTO: 'Aprovar relatório de execução enviado para conhecimento',
        USUARIO_AGENCIA: 'Usuário Agência',
        USUARIO_FUNDACAO: 'Usuário Fundação',
        USUARIO_ENTIDADE: 'Usuário Entidade',
        USUARIO_ESTRATEGICO: 'Usuário Parceiro Estratégico',
        USUARIO_SUPERINTENDENCIA: 'Usuário Superintendência',
        PERFIL: 'Perfil',
        ENTIDADE: 'Entidade',
        EDITAL: 'Edital / Processo Simplificado',
        DOCUMENTO: 'Documento',
        ACOES_PROPRIEDADES: 'Ações e Proprietário',
        MINHA_ENTIDADE: 'Minha Entidade',
        PERMISSAO: 'Permissão',
        TIPO_DOCUMENTO: 'Tipo Documento',
        PROPOSTA: 'Proposta',
        MINHA_PROPOSTA: 'Minha Proposta',
        PARCEIRO_ESTRATEGICO: 'Parceiro Estratégico',
        PRE_ANALISE: 'Pré-Análise da Proposta',
        ACEITE: 'Aceite da Proposta',
        ANALISE: 'Análise da Proposta',
        DEFERIMENTO: 'Deferimento da Proposta',
        PREPARACAO_DOCUMENTOS: 'Preparação de Documentos da Proposta',
        FORMALIZAR_PROJETOS: 'Formalizar Projetos',
        FAV: 'FAV - Ficha de Auto Verificação',
        GED: 'GED - Gestão de Documentos',
        SOLICITACAO_PAGAMENTO: 'Solicitação de Pagamento',
        SOLICITACAO_CONTRAPARTIDA: 'Solicitação de Contrapartida',
        SOLICITACAO_ADIANTAMENTO: 'Solicitação de Adiantamento',
        SOLICITACAO_DEVOLUCAOADIANTAMENTO: 'Solicitação de Devolução de Adiantamento',
        SOLICITACAO_PRESTACAOCONTAS: 'Solicitação de Prestação de Contas',
        RELATORIO: 'Relatório de Execução',
        RELATORIOS_ERP: 'Relatórios do ERP',
        CONFIGURACOES: 'Configurações do Sistema',
        DASHBOARD: 'Dashboard',
        PROJETO: 'Projeto',
        MEU_PROJETO: 'Meu Projeto',
        MEU_PARCEIRO_ESTRATEGICO: 'Meu parceiro estratégico'
      }
    },
    MY_PREFERENCES: {
      SUCCESS: 'Sucesso',
      SUCCESS_CHANGE_PHOTO: 'Foto alterada com sucesso',
      SUCCESS_CHANGE_PASSWORD: 'Senha alterada com sucesso',
      SUCCESS_CHANGE_PREFERENCE: 'Preferência alterada com sucesso'
    },
    STRATEGIC_PARTNER: {
      INCOMPLETO: 'Incompleto',
      PENDENTE_APROVACAO: 'Aguardando aprovação',
      COMPLETO: 'Completo'
    }
  }
}



// WEBPACK FOOTER //
// ./static/i18n/pt_BR.js